import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'underscore';

import ResponsesManager from '../questions/responsesManager'
import questionActions from '../../actions/questions';
import { IncorrectSequencesInputAndConceptSelectorForm, } from '../../../Shared/index';

class NewIncorrectSequencesContainer extends Component {
  constructor() {
    super();

    const questionType = 'questions'
    const questionTypeLink = 'questions'
    const actionFile = questionActions

    this.state = { questionType, actionFile, questionTypeLink };
  }

  componentDidMount() {
    const { actionFile } = this.state
    const { getUsedSequences } = actionFile
    const { dispatch, generatedIncorrectSequences, match } = this.props
    const { used } = generatedIncorrectSequences
    const { params } = match
    const { questionID } = params
    if (!used[questionID] && getUsedSequences) {
      dispatch(getUsedSequences(questionID))
    }
  }

  submitSequenceForm = data => {
    const { actionFile } = this.state
    const { submitNewIncorrectSequence } = actionFile
    const { dispatch, match, history, questions } = this.props
    const incorrectSequences = questions.data[match.params.questionID].incorrectSequences
    delete data.conceptResults.null;
    data.order = _.keys(incorrectSequences).length;
    const url = match.url.replace('/new', '')
    const callback = () => {
      history.push(url)
    }
    dispatch(submitNewIncorrectSequence(match.params.questionID, data, callback));
  };

  render() {
    const { generatedIncorrectSequences, match, questions, } = this.props
    const { used } = generatedIncorrectSequences
    const { params } = match
    const { questionID } = params
    return (
      <div>
        <IncorrectSequencesInputAndConceptSelectorForm
          itemLabel='Incorrect Sequence'
          onSubmit={this.submitSequenceForm}
          questionID={questionID}
          questions={questions}
          ResponsesManager={ResponsesManager}
          states
          usedSequences={used[questionID]}
        />
      </div>
    );
  }
}

function select(props) {
  return {
    questions: props.questions,
    generatedIncorrectSequences: props.generatedIncorrectSequences,
    states: props.states
  };
}

export default connect(select)(NewIncorrectSequencesContainer);
